var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabs',{key:'procedure_tabs_' + _vm.procedureId,attrs:{"entity-type":"procedure","entity-id":_vm.procedureId,"tabs":_vm.tabs}})}
var staticRenderFns = []

export { render, staticRenderFns }